import { IndexDBService } from '@/shared/plugins/files-cache/services/index-db.service';

/**
 * Helper class to abstract out basic local cache operations (LocalStorage / IndexedDB)
 */
export default class CacheOperations {
  private static instance: CacheOperations = null;
  private useIndexedDB = false;
  private indexedDBOpened = false;
  private indexedDBService: IndexDBService;

  private constructor() {
    if (window.indexedDB) {
      this.useIndexedDB = true;
      this.indexedDBService = new IndexDBService();
    }
  }

  public static getInstance(): CacheOperations {
    if (this.instance === null) {
      this.instance = new CacheOperations();
    }
    return this.instance;
  }

  async getItem(key: string) {
    await this.checkIndexedDBOpen();
    if (this.useIndexedDB) {
      return this.indexedDBService.getValue(key);
    }
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  }

  async setItem(key: string, val: any) {
    await this.checkIndexedDBOpen();
    if (this.useIndexedDB) {
      await this.indexedDBService.saveValue(key, val);
    }
    else {
      localStorage.setItem(key, JSON.stringify(val));
    }
  }

  async deleteItem(key: string) {
    await this.checkIndexedDBOpen();
    if (this.useIndexedDB) {
      await this.indexedDBService.deleteValue(key);
    }
    else {
      localStorage.removeItem(key);
    }
  }

  private async checkIndexedDBOpen() {
    if (this.useIndexedDB && !this.indexedDBOpened) {
      const successfullyOpened = await this.indexedDBService.openDB();
      if (successfullyOpened) {
        this.indexedDBOpened = true;
      }
      else {
        this.useIndexedDB = false;
      }
    }
  }
}
